export default __webpack_public_path__ + "static/media/aj-1.33b6cb36.jpg";